module.exports = __webpack_public_path__ + "img/card_comunicacion.35451144.jpg";